<script lang="ts">
  import {getBaseUrl} from "$lib/baseUrlResolver";
  import {diffState} from "$lib/stores/masterdataStore";
  import {fetchDiff} from "$lib/services/MasterdataService";
  import {errorDetails, errorState} from "$lib/stores/errorState";

  const {originatingEnv} = $props();

  let file = $state<File | null>(null);
  const excelTemplateUrl = `${getBaseUrl()}/downloads/installations_template.xls`;

  async function handleSubmit(e: Event) {
    e.preventDefault();

    if (!file) {
      errorDetails.set("Please select a file to upload.");
      errorState.set('Error')
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("originatingEnv", originatingEnv);
    await fetchDiff(formData);
  }

  function handleFileChange(e: Event) {
    const input = e.target as HTMLInputElement;
    file = input.files?.[0] ?? null;
    errorDetails.set(null)
    diffState.set('Idle')
    errorState.set("OK")
  }
</script>

<form onsubmit={handleSubmit} class="upload-form">
  <div class="my-1">
    Import the properly formatted Excel file (.xls) to add or change stores.
  </div>

  <input id="file" type="file" onchange={handleFileChange}/>

  <div class="inline-flex mt-1">
    <button type="submit" class="btn btn-primary-light">
      Import file
    </button>

    <a href={excelTemplateUrl} download class="btn btn-primary-light content-center ml-1">
      Get Excel template
    </a>
  </div>
</form>
